import classnames from 'classnames';

export type OpenModalProps = { openModal?: () => void; className?: string };
export function OpenModalButton({ openModal, className }: OpenModalProps) {
  return (
    <a
      className={classnames('btn btn-icon btn-sm btn-link text-primary', className)}
      onClick={e => {
        e.stopPropagation();
        openModal?.();
      }}
    >
      <em className="icon">fullscreen</em>
    </a>
  );
}
